import { render, staticRenderFns } from "./packageDetail.vue?vue&type=template&id=1cc2bde0&scoped=true"
import script from "./packageDetail.vue?vue&type=script&lang=js"
export * from "./packageDetail.vue?vue&type=script&lang=js"
import style0 from "./packageDetail.vue?vue&type=style&index=0&id=1cc2bde0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc2bde0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cc2bde0')) {
      api.createRecord('1cc2bde0', component.options)
    } else {
      api.reload('1cc2bde0', component.options)
    }
    module.hot.accept("./packageDetail.vue?vue&type=template&id=1cc2bde0&scoped=true", function () {
      api.rerender('1cc2bde0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/DeliveryLoading/component/packageDetail.vue"
export default component.exports